import { render, staticRenderFns } from "./datafile-upload-confirmation-modal.vue?vue&type=template&id=db30e264"
import script from "./datafile-upload-confirmation-modal.vue?vue&type=script&lang=js"
export * from "./datafile-upload-confirmation-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports